import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

import styled, { keyframes } from 'styled-components'
import { Logo } from './LogoRanking'

const Hrail = keyframes`
  0% {
    transform: translate3d(0, 0, 0); }
  100% {
    transform: translate3d(-100%, 0, 0); } 
`

const StHero = styled.div`
  position: relative;
  padding-top: 4rem;
  text-align: center;
  min-height: 50vh;

  .bg {
    position: absolute;
    top: 0rem;
    left: 0rem;
    right: 0rem;
    bottom: 0rem;
    overflow: hidden;
    z-index: -1;
    &:after {
      content: '';
      position: absolute;
      top: -10rem;
      left: -10rem;
      right: -10rem;
      bottom: -20rem;
      z-index: -1;

      background-image: linear-gradient(
        135deg,
        #001d35,
        #ffa71b,
        #f37022,
        #cb3515,
        #c83d15,
        #64192f,
        #011e37,
        #e35238
      );
      opacity: 0.8;
      filter: blur(10px);
    }
  }

  z-index: 1;
  .anim-font {
    transition-delay: 0.1s;
    transition: transform 1.5s cubic-bezier(0.075, 0.82, 0.165, 1),
      opacity 1.5s cubic-bezier(0.075, 0.82, 0.165, 1);
    transform: translateY(0);
    opacity: 1;
    overflow: hidden;
    white-space: nowrap;
  }
  .anim-font--wrap {
  }
  .anim-font--text {
    display: inline-block;
    animation: ${Hrail} 10s linear infinite;
    font-size: 50rem;
    padding-left: 10vw;
    padding-right: 10vw;
  }
  .anim-font--text-normal {
    color: white;
  }
  .anim-font--text-stroke {
    color: transparent;
    -webkit-text-stroke: 10px #4c0e2f;
    text-stroke: 10px #4c0e2f;
  }
  .font-bg {
    position: absolute;
    top: -1rem;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;

    h1 {
      font-weight: bold;
    }
  }

  @media (orientation: portrait) {
    padding: 1rem;
    margin-top: 4rem;
  }
  @media (max-width: 768px) {
    padding: 1rem;
    margin-top: 4rem;
  }
  .logo {
    height: 100%;
    width: calc(50vw - 120px);
    z-index: 2;
    min-height: 60vh;
    height: 100%;
    @media (max-width: 768px) {
      width: 100%;
      min-height: 20vh;
    }
  }
  .cols {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    @media (orientation: portrait) {
      grid-template-columns: 1fr;
    }
    .col01 {
      position: relative;
    }

    .col02 {
      margin-left: -10%;
      margin-bottom: -20%;
      margin-right: -30%;
      @media (orientation: portrait) {
        margin-left: inherit;
        margin-bottom: inherit;
        margin-right: inherit;
      }
    }
  }
  .max-w-screen-xs {
    max-width: 450px;
  }
`

const Hero = () => {
  return (
    <StHero>
      <div className="content">
        <div className="relative max-w-screen-sm p-3 mx-auto md:max-w-screen-xl sm:p-8">
          <div className="cols">
            <div className="col01">
              <h1 className="m-0 text-6xl leading-none">
                <Logo className="logo" theme="dark" />
              </h1>

              <p className="pt-8 pb-8 mt-0 text-2xl leading-tight text-left max-w-screen-xs ">
                El estudio mide la percepción de calidad que el mercado laboral
                asocia a cada plantel, gestión, calidad de académicos y alumnos,
                y nivel de investigación de las instituciones chilenas.
              </p>
            </div>
            <div className="col02">
              {/* <StaticImage
                className="img-ai"
                src="./imgs/00071.png"
                alt="Joven 2022 1"
              /> */}
              <StaticImage
                className="img-ai"
                src="./imgs/00072.png"
                alt="Joven 2022 1"
                formats={['auto', 'webp', 'avif']}
                loading="eager"
                placeholder="blurred"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="anim-font font-bg">
        <div className="anim-font--wrap">
          <h1 className="anim-font--text anim-font--text-stroke">2022</h1>
          <h1 className="anim-font--text anim-font--text-stroke">2022</h1>
        </div>
      </div>
      <div className="bg"></div>
    </StHero>
  )
}

export default Hero
